import React, { Component, useState, useEffect, memo } from "react";
import { Input, CustomInput, Button, Badge } from "reactstrap";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { AddCommaNumber } from "../../../helpers/Utils";
import { injectIntl } from "react-intl";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import moment from "moment";

// --- Editable Cell Components ---
const EditableCell = memo(
  ({ value, onChange, placeholder = "", className = "" }) => {
    const [localValue, setLocalValue] = useState(value || "");

    useEffect(() => {
      setLocalValue(value || "");
    }, [value]);

    const handleBlur = () => {
      if (localValue !== value) onChange(localValue);
    };

    return (
      <Input
        type="text"
        bsSize="sm"
        className={className}
        value={localValue}
        placeholder={placeholder}
        onChange={(e) => setLocalValue(e.target.value)}
        onBlur={handleBlur}
      />
    );
  },
);

class ContentMultiForm extends Component {
  handleCellChange = (index, field, value) => {
    const { data, onUpdateData } = this.props;
    if (!data || !data[index]) return;

    const updatedItem = { ...data[index], [field]: value };
    if (onUpdateData) onUpdateData([updatedItem]);
  };

  getColumns = () => {
    const {
      intl,
      selectedItems,
      toggleItem,
      toggleItemLog,
      onViewItems,
      onSelectAll,
    } = this.props;
    return [
      {
        Header: (props) => {
          return (
            <div className="d-flex justify-content-center w-100">
              <CustomInput
                type="checkbox"
                id="checkAll"
                label=""
                className="cursor-pointer"
                style={{ cursor: "pointer" }}
                checked={
                  selectedItems &&
                  selectedItems.length > 0 &&
                  selectedItems.length >= this.props.data.length
                }
                onChange={() => onSelectAll(true)}
              />
            </div>
          );
        },
        accessor: "id",
        width: 50,
        sortable: false,
        Cell: (cellProps) => {
          return (
            <div className="d-flex justify-content-center w-100">
              <CustomInput
                type="checkbox"
                id={`check_${cellProps.value}`}
                label=""
                className="cursor-pointer"
                style={{ cursor: "pointer" }}
                checked={
                  selectedItems && selectedItems.includes(cellProps.value)
                }
                onChange={() => toggleItem(cellProps.value)}
              />
            </div>
          );
        },
      },
      {
        Header: intl.formatMessage({ id: "provider.header.name" }),
        accessor: "name",
        minWidth: 150,
        Cell: (props) => (
          <EditableCell
            value={props.value}
            className="text-capitalize"
            onChange={(val) => this.handleCellChange(props.index, "name", val)}
          />
        ),
      },
      {
        Header: intl.formatMessage({ id: "provider.header.phone" }),
        accessor: "phone",
        Cell: (props) => (
          <EditableCell
            value={props.value}
            onChange={(val) => this.handleCellChange(props.index, "phone", val)}
          />
        ),
      },
      {
        Header: intl.formatMessage({ id: "provider.header.email" }),
        accessor: "email",
        Cell: (props) => (
          <EditableCell
            value={props.value}
            className="text-lowercase"
            onChange={(val) => this.handleCellChange(props.index, "email", val)}
          />
        ),
      },
      {
        Header: intl.formatMessage({ id: "provider.header.address" }),
        accessor: "address",
        Cell: (props) => (
          <EditableCell
            value={props.value}
            className="text-capitalize"
            onChange={(val) =>
              this.handleCellChange(props.index, "address", val)
            }
          />
        ),
      },
      {
        Header: "Số lần nhập",
        id: "items_count",
        accessor: (d) => d.company_provider_item?.length || 0,
        width: 100,
        Cell: (props) => (
          <div className="w-100 text-center">
            <Badge
              color="outline-secondary"
              pill
              className="cursor-pointer font-weight-bold"
              style={{ fontSize: "12px", padding: "5px 10px" }}
              onClick={() => onViewItems(props.original)}
            >
              {props.value} lần
            </Badge>
          </div>
        ),
      },
      {
        Header: intl.formatMessage({ id: "provider.header.remaining" }),
        accessor: "total_price_pending",
        width: 100,
        Cell: (props) => {
          const val = parseInt(props.value) || 0;
          return (
            <div
              className={`w-100 text-center pr-2 font-weight-bold ${val > 0 ? "text-danger" : ""}`}
            >
              {AddCommaNumber(val)}
            </div>
          );
        },
      },
      {
        Header: "Nhập gần nhất",
        id: "last_import",
        accessor: (d) => {
          if (!d.company_provider_item || d.company_provider_item.length === 0)
            return null;
          const dates = d.company_provider_item
            .map((i) => (i.createdAt ? new Date(i.createdAt).getTime() : 0))
            .filter((t) => t > 0);
          return dates.length > 0 ? Math.max(...dates) : null;
        },
        width: 120,
        Cell: (props) => (
          <div className="w-100 text-center text-muted">
            {props.value ? moment(props.value).format("DD/MM/YYYY") : "-"}
          </div>
        ),
      },
      {
        Header: "Thanh toán",
        id: "pay_action",
        width: 120,
        sortable: false,
        Cell: (props) => {
          const provider = props.original;
          const hasDebt = parseInt(provider.total_price_pending) > 0;
          if (!hasDebt) return null;
          return (
            <div className="d-flex justify-content-center w-100">
              <Button
                outline
                color="success"
                size="xs"
                className="pt-1 pb-1 pl-2 pr-2"
                onClick={() => {
                  const itemToPay = provider.company_provider_item?.find(
                    (item) =>
                      (item.price_income || 0) - (item.price_outcome || 0) > 0,
                  );
                  if (itemToPay) {
                    toggleItemLog(itemToPay);
                  }
                }}
              >
                Thanh toán nợ
              </Button>
            </div>
          );
        },
      },
    ];
  };

  render() {
    const { data } = this.props;

    return (
      <div className="company-provider-multi-form-container">
        <style>{`
          .company-provider-multi-form-container .rt-thead.-header {
            box-shadow: none;
            border-bottom: 1px solid #f3f3f3;
          }
          .company-provider-multi-form-container .rt-th {
            padding: 12px 5px;
            font-weight: 700;
            text-align: center;
            color: #333;
            background: #f8f8f8;
          }
          .company-provider-multi-form-container .rt-td {
            padding: 6px 5px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #f3f3f3;
          }
          .company-provider-multi-form-container .rt-tr:hover {
            background: #fcfcfc;
          }
          .company-provider-multi-form-container .rt-tr,
          .company-provider-multi-form-container .rt-td {
            outline: none !important;
          }
          .company-provider-multi-form-container input.form-control-sm {
            height: 32px;
            font-size: 13px;
            border-color: #ebedf2 !important;
            background: #fff !important;
          }
          .company-provider-multi-form-container input.form-control-sm:hover {
            border-color: #d1d1d1 !important;
          }
          .company-provider-multi-form-container input.form-control-sm:focus {
            border-color: #80bdff !important;
            background: #fff !important;
            box-shadow: 0 0 0 0.1rem rgba(0,123,255,0.1) !important;
          }
          .company-provider-multi-form-container .cursor-pointer {
            cursor: pointer;
          }
        `}</style>

        <PerfectScrollbar
          options={{ suppressScrollX: false, suppressScrollY: false }}
          style={{ width: "100%", maxHeight: "70vh" }}
        >
          <div style={{ minWidth: "100%", width: "max-content" }}>
            <ReactTable
              data={data || []}
              columns={this.getColumns()}
              defaultPageSize={20}
              showPagination={true}
              PaginationComponent={Pagination}
              minRows={1}
              NoDataComponent={() => (
                <div className="text-muted p-5 text-center">
                  Chưa có dữ liệu...
                </div>
              )}
              className="-striped -highlight"
            />
          </div>
        </PerfectScrollbar>
      </div>
    );
  }
}

export default injectIntl(ContentMultiForm);
